export default "__VITE_ASSET__Bjr5H9Mu__"